export default __webpack_public_path__ + "static/media/footerbanner.420298ed.png";